import type { ReactElement } from "react";
import { Icon } from "@kundeninfo/ui";
import "./Navigation.css";

export type NavigationProps = {
  /** "seite" für die Randspalte (Tablet/Desktop), "leiste" für die untere Reihe (iPhone). */
  orientation: "seite" | "leiste";
};

/**
 * Die Hauptnavigation der Anwendung — nicht zu verwechseln mit den Tabs der Kundenakte
 * (KundenAkte.tsx), die innerhalb eines Kunden liegen. In Paket 1 gibt es nur "Kunden";
 * die übrigen Module stehen sichtbar, aber stumm geschaltet, damit die Reihenfolge und
 * Vollständigkeit der Navigation von Anfang an feststeht.
 */
const EINTRAEGE: { id: string; label: string; icon: string; aktiv: boolean }[] = [
  { id: "kunden", label: "Kunden", icon: "users", aktiv: true },
  { id: "angebote", label: "Angebote", icon: "file-lines", aktiv: false },
  { id: "auftraege", label: "Aufträge", icon: "file-contract", aktiv: false },
  { id: "artikel", label: "Artikel", icon: "box", aktiv: false },
  { id: "schnittstellen", label: "Schnittstellen", icon: "plug", aktiv: false },
  { id: "einstellungen", label: "Einstellungen", icon: "gear", aktiv: false },
];

export function Navigation({ orientation }: NavigationProps): ReactElement {
  return (
    <nav className={`nv nv--${orientation}`} aria-label="Hauptnavigation">
      {EINTRAEGE.map((e) => (
        <button
          key={e.id}
          type="button"
          className={`nv__eintrag${e.aktiv ? " nv__eintrag--aktiv" : ""}`}
          disabled={!e.aktiv}
          aria-current={e.aktiv ? "page" : undefined}
          title={e.aktiv ? undefined : "Kommt in einem späteren Paket."}
        >
          <Icon name={e.icon} size={18} />
          <span className="nv__label">{e.label}</span>
        </button>
      ))}
    </nav>
  );
}
